import { render, staticRenderFns } from "./EployeeRouters.vue?vue&type=template&id=01b72a54&"
import script from "./EployeeRouters.vue?vue&type=script&lang=js&"
export * from "./EployeeRouters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports